// pass noErrorPage as true to allow the caller to manage errors
// eg if the card query fails, rather than routing to 404 we show the empty set
export async function fetchApi<T>(
  url: string,
  noErrorPage?: boolean
): Promise<T | null> {
  let response: Response;

  const error = (code: number) => {
    if (noErrorPage) return null;
    window.location.pathname = `/error/${code}`;
    return null;
  };

  try {
    response = (await fetch(url)) as Response;

    if (!response.ok) {
      return error(response.status);
    }

    return response.json();
  } catch (err) {
    return error(404)
  }
}
